// document.addEventListener("DOMContentLoaded", function () {
//   const sliders = document.querySelectorAll(".custom-slider");

//   sliders.forEach(slider => {
//     const wrapper = slider.querySelector(".slider-wrapper");
//     const slides = slider.querySelectorAll(".slide");
//     const dotsContainer = slider.querySelector(".slider-dots");

//     let currentIndex = 0;

//     slides.forEach((_, index) => {
//       const dot = document.createElement("button");
//       if (index === 0) dot.classList.add("active");
//       dot.addEventListener("click", () => goToSlide(index));
//       dotsContainer.appendChild(dot);
//     });

//     const dots = dotsContainer.querySelectorAll("button");

//     function goToSlide(index) {
//       currentIndex = index;
//       wrapper.style.transform = `translateX(-${100 * index}%)`;
//       dots.forEach(d => d.classList.remove("active"));
//       dots[index].classList.add("active");
//     }
//   });
// });

document.addEventListener("DOMContentLoaded", function () {
  const sliders = document.querySelectorAll(".custom-slider");

  sliders.forEach(slider => {
    const wrapper = slider.querySelector(".slider-wrapper");
    const slides = slider.querySelectorAll(".slide");
    const dotsContainer = slider.querySelector(".slider-dots");

    let currentIndex = 0;
    let autoplayInterval;

    // Create dots
    slides.forEach((_, index) => {
      const dot = document.createElement("span");
      dot.classList.add("dot")
      if (index === 0) dot.classList.add("active");
      dot.addEventListener("click", () => {
        goToSlide(index);
        resetAutoplay(); // restart autoplay after manual click
      });
      dotsContainer.appendChild(dot);
    });

    const dots = dotsContainer.querySelectorAll(".dot");

    function goToSlide(index) {
      currentIndex = index;
      wrapper.style.transform = `translateX(-${100 * index}%)`;
      dots.forEach(d => d.classList.remove("active"));
      dots[index].classList.add("active");
    }

    function nextSlide() {
      currentIndex = (currentIndex + 1) % slides.length;
      goToSlide(currentIndex);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 4000); // 4 seconds
    }

    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }

    // Init
    goToSlide(0);
    startAutoplay();

  });
});
